export default __webpack_public_path__ + "static/media/icon-love-poppy.176da967.webp";